import React from 'react';
//import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../styles/FirstLevelMenu.css';

import {ReactComponent as CameraSetup} from '../icons/camera-setup-icon.svg';
import {ReactComponent as CustomPicture} from '../icons/custom-picture-icon.svg';
import {ReactComponent as RecordingSetup} from '../icons/recording-icon.svg';
import {ReactComponent as AudioSetup} from '../icons/audio-setup-icon.svg';
import {ReactComponent as MonitoringSetup} from '../icons/monitoring-setup-icon.svg';
import {ReactComponent as AssistanceFunctions} from '../icons/assistance-icon.svg';
import {ReactComponent as NetworkSettings} from '../icons/network-settings-icon.svg';
import {ReactComponent as AssingnableButtons} from '../icons/assignable-buttons-icon.svg';
import {ReactComponent as SystemSetup} from '../icons/system-setup-icon.svg';
import {ReactComponent as MyMenu} from '../icons/my-menu-icon.svg';
import {ReactComponent as CloseIcon} from '../icons/close-icon.svg';

const icons = {
  camera_setup: <CameraSetup className="Icon-menu"/>,
  custom_picture_hdr: <CustomPicture className="Icon-menu"/>,
  recording_media_setup: <RecordingSetup className="Icon-menu" />,
  audio_setup: <AudioSetup className="Icon-menu" />,
  monitoring_setup: <MonitoringSetup className="Icon-menu" />,
  assistance_functions: <AssistanceFunctions className="Icon-menu" />,
  network_settings: <NetworkSettings className="Icon-menu" />,
  assignable_buttons: <AssingnableButtons className="Icon-menu" />,
  system_setup: <SystemSetup className="Icon-menu" />,
  my_menu: <MyMenu className="Icon-menu" />,
  close: <CloseIcon className="Icon-menu" />,
}

const FirstLevelMenu = ({ menuLevel, firstLevelIndex, data }) => { 
  const firstLevelMenu = Object.keys(data);
  const menuClassName = menuLevel === 1 ? 'Screen-header First-level-menu First-level-menu-active' : 'Screen-header First-level-menu';

  return (
    <ul className={menuClassName}>
      {firstLevelMenu.map((menuItem, index) => {
        const itemClassName = index === firstLevelIndex ? 'First-level-item First-level-item-active' : 'First-level-item';
        const icon = menuItem.replace(/[" ", "/"]/g, "_").toLowerCase();
        return (
          <li key={icon} className={itemClassName}>
            {icons[icon]}
          </li>
        );
      })}
    </ul>
  );
};

// FirstLevelMenu.propTypes = {
//   menuLevel: PropTypes.number.isRequired,
//   firstLevelMenu: PropTypes.arrayOf(PropTypes.string).isRequired,
//   firstLevelIndex: PropTypes.number.isRequired,
// };

function mapStateToProps(reduxState) {
  return {
    menuLevel: reduxState.menuLevel,
    firstLevelIndex: reduxState.firstLevelIndex,
    data: reduxState.data,
  }
}

export default connect(mapStateToProps)(FirstLevelMenu);





